import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function BetaBanner({ onOpenPopup }) {
    const { t } = useTranslation('beta');
    const [visible, setVisible] = useState(true);

    if (!visible) return null;

    return (
        <div style={{
            background: 'linear-gradient(135deg, #EB3333, #c0392b)',
            color: '#fff',
            padding: '12px 20px',
            textAlign: 'center',
            fontSize: 14,
            position: 'relative',
            zIndex: 100,
        }}>
            <span>🚀 </span>
            <strong>{t('bannerTitle')}</strong>
            {' — '}
            {t('bannerText')}
            {' '}
            <button
                type="button"
                onClick={onOpenPopup}
                style={{
                    background: '#fff',
                    color: '#EB3333',
                    border: 'none',
                    borderRadius: 6,
                    padding: '4px 12px',
                    cursor: 'pointer',
                    fontWeight: 700,
                    marginLeft: 8,
                    fontSize: 13,
                }}
            >
                {t('bannerButton')}
            </button>
            <button
                type="button"
                onClick={() => setVisible(false)}
                aria-label={t('close')}
                style={{
                    position: 'absolute',
                    right: 12,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    color: 'rgba(255,255,255,0.7)',
                    cursor: 'pointer',
                    fontSize: 18,
                }}
            >
                ×
            </button>
        </div>
    );
}
